<script>
  import {
    warehouseMethods,
  } from '@state/helpers'


  export default {
    props: {
      collapse: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        warehouses: [],
        boundCollapse: false,
      }
    },
    computed:{
      filters(){
        return this.warehouses.map(el => {
          if (el.selected){
            return el.id
          }
        }).filter(el => el)
      }
    },
    watch: {
      filters (val) {
        this.$emit('filter', {
          warehouse_ids: val,
        })
      },
    },
    async created() {
      this.boundCollapse = Boolean(this.collapse)
      this.boundCollapse = !this.boundCollapse

      return this.loadWarehouses()
    },
    methods: {
      ...warehouseMethods,
      async loadWarehouses () {
        const { data } = await this.getWarehouses({ limit: 200 })
        const warehouses = data.data
        warehouses.forEach(el => el.selected = false)
        this.warehouses = warehouses
      },
    },
  }
</script>

<template>
  <div v-bind="$attrs" class="block-item">
    <div class="block-heading">
      <h3
        v-fabric-collapse.accordion-warehouse
        class="
          tw-flex tw-items-center
          tw-text-positive
          tw-leading-relaxed tw-font-medium tw-text-base">
        <a class="tw-no-underline" href="javascript:">Filter by warehouse</a>
        <BaseChevronRotate
          transition-class="rotate-360-270"
          :toggle="!boundCollapse"
          :duration="500"
        />
      </h3>
      <FabricBadge
        :styling-bg="filters.length ? 'badge-primary' : 'badge-light'"
        :copy="filters.length"
      />
    </div>
    <FabricCollapse
      id="accordion-warehouse"
      v-model="boundCollapse"
      hide-header
      :duration="500"
      :default-shown="boundCollapse">
      <div
        class="block-content"
        :class="{ 'ovf-y-scroll scroll-primary mg-r-5 pd-t-u mg-t-10 mx-h-300': (warehouses && warehouses.length > 8) }">
        <FabricCheckbox
          v-for="warehouse in warehouses" 
          :key="warehouse.id"
          v-model="warehouse.selected"
          slot-classes="tw-pl-3 tw-text-black"
        >{{ warehouse.name }}</FabricCheckbox>
      </div>
    </FabricCollapse>
  </div>
</template>
